<template>
  <div>
    <el-dialog title='提交审核' :visible.sync='auditVisible' width='1050px' @close='auditClose' center
               :close-on-click-modal='false'>
      <div class='depart'>
        <el-form :model='auditData' label-width='120px' :rules='rules2' ref='ruleForm2'
                 size='medium'>

          <div-border label='开票选择' divStyle='margin-top: 10px;padding-top:15px;'>
            <el-row>
              <el-col :span='12'>
                <el-form-item label='购买方名称：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserName }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方名称：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerName }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserDentificaNumber }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerDentificaNumber }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方地址：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserAddress }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方地址：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerAddress }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方电话：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserTel }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方电话：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerTel }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方开户行：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserBankDeposit }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方开户行：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerBankDeposit }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='购买方银行账号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.purchaserBankAccount }}
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='销售方银行账号：' label-width='150px' style='margin-bottom: 0'>
                  {{ auditData.sellerBankAccount }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label='是否开具销售清单：' label-width='150px' prop='type'>
              <el-radio v-model='isSalesList' :label='0'>否</el-radio>
              <el-radio v-model='isSalesList' :label='1'>是</el-radio>
            </el-form-item>

            <div>
              <el-row type='flex' justify='space-between' align='middle'
                      style='margin-bottom: 10px;'>
                <el-col :span='12'>
                  <el-button type='primary' @click='addInvoice'>添加</el-button>
                </el-col>
                <el-col :span='12'>
                  <div style='float: right'>
                    结算数量：{{ auditData.settlementNum }}
                    剩余未结算数量：{{ settlementQuantityCalculation }}
                    其他数量：{{ auditData.otherNum }}
                    剩余其他未结算数量：{{ otherNumCalculation }}
                  </div>
                </el-col>
              </el-row>
              <div class='tableContainer'>
                <el-table
                  :data='invoiceTableData'
                  style='width: 100%;margin-bottom: 10px;'
                  border
                  stripe
                  :header-cell-style='headerCellStyle'
                  :cell-style='cellStyle'
                >
                  <el-table-column label='序号' align='center' type='index' />
                  <el-table-column width='160px' label='服务名称' prop='serviceName' align='center'
                                   show-overflow-tooltip />
                  <el-table-column width='200px' label='规格型号' prop='specificaModel' align='center'
                                   show-overflow-tooltip />
                  <el-table-column label='结算数量' prop='settlementNum' align='center'
                                   show-overflow-tooltip />
                  <el-table-column width='120p' x label='其它结算数量' prop='otherNum' align='center'
                                   show-overflow-tooltip />
                  <el-table-column width='150px' label='不含税金额' prop='price' align='center'
                                   show-overflow-tooltip />
                  <el-table-column label='税率(%)' prop='taxRate' align='center'
                                   show-overflow-tooltip />
                  <el-table-column label='含税金额' prop='taxPrice' align='center'
                                   show-overflow-tooltip />
                  <el-table-column width='200px' label='是否抵扣开票' align='center'
                                   show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{ scope.row.isDeduct ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width='200px' label='是否抵扣超出合同价对账单' align='center'
                                   show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{ scope.row.isDeductionPrice ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width='200px' label='是否暂缓开票' prop='se' align='center'
                                   show-overflow-tooltip>
                    <template slot-scope='scope'>
                      {{ scope.row.isSuspendBilling ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width='200px' label='操作' align='center' fixed='right'>
                    <template slot-scope='scope'>
                      <el-button type='warning' size='small'
                                 @click='editTableClick(scope.row.id)'>编辑
                      </el-button>
                      <el-button type='danger' size='small'
                                 @click='deleteTableClick(scope.row.id)'>
                        删除
                      </el-button>

                    </template>
                  </el-table-column>
                </el-table>
                <div style='padding-bottom: 8px;display: flex;justify-content: flex-end;'
                     v-if='invoiceTableData && invoiceTableData.length > 0'>
                  开票合计含税金额：{{ invoiceTableData[0].taxTotalPrice }}
                  开票合计不含税金额：{{ invoiceTableData[0].totalprice }}
                </div>
              </div>
            </div>
          </div-border>
          <div class='btnContainer'>
            <el-button size='medium' class='searchBtn' @click='auditConfirmClick'
                       :disabled='!(settlementQuantityCalculation === 0 && otherNumCalculation === 0)'>
              确定
            </el-button>
            <el-button size='medium' class='resetBtn' @click='auditClose'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 创建发票 -->
    <el-dialog
      title='创建发票'
      :visible.sync='addInvoiceVisible'
      width='950px'
      @close='addInvoiceClose'
      center
      :close-on-click-modal='false'>
      <div class='depart'>
        <add-invoice ref='addInvoice' @addInvoiceClose='addInvoiceClose' />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    deleteInvoice,
    getInvoiceInfo, getInvoiceList,
    infoInvoice,
    submitAuditInvoice,
  } from '@/service/getData';
  import AddInvoice from '@/views/settle/client/components/addInvoice';
  import DivBorder from '@/components/divBorder.vue';

  export default {
    name: 'submitReview',
    components: {
      AddInvoice,
      DivBorder,
    },
    data() {
      return {
        addInvoiceVisible: false,
        auditVisible: false,
        auditData: {},
        isSalesList: 0, // 是否开具销售清单,
        basicId: '',
        purchaserId: '',
        rules2: {
          isSalesList: [
            {
              required: true,
              message: '请选择是否开具销售清单',
              trigger: 'change',
            },
          ],
        },
        invoiceTableData: [], // 发票数据
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        cellStyle: {
          color: '#7F7F7F',
          'font-size': '13px',
          height: '52px',
        },
      };
    },
    computed: {
      settlementQuantityCalculation() {
        let returnStr = this.auditData.settlementNum;
        this.invoiceTableData.forEach(res => {
          if (res.settlementNum) {
            returnStr -= res.settlementNum;
          }
        });
        this.settlementNum = returnStr;
        return returnStr;
      },
      otherNumCalculation() {
        let returnStr = this.auditData.otherNum;
        this.invoiceTableData.forEach(res => {
          if (res.otherNum) {
            returnStr -= res.otherNum;
          }
        });
        this.otherNum = returnStr;
        return returnStr;
      },
    },
    methods: {
      dialogOpen(id,reconciliator) {
        this.auditVisible = true;
        this.auditData.reconciliator = reconciliator
        this.getDetail(id);
      },
      async getDetail(id) {
        const {
          status,
          data,
          message,
        } = await getInvoiceInfo(id);
        if (status !== 0) return this.$message.error(message);
        this.auditData = data;
        this.basicId = id;
        this.purchaserId = data.purchaserId;
        this.auditVisible = true;
        this.$nextTick(() => {
          this.getInvoiceList(id);
        });
      },
      auditClose() {
        this.auditVisible = false;
        this.$refs.ruleForm2.resetFields();
      },
      addInvoice() {
        this.addInvoiceVisible = true;
        this.$nextTick(() => {
          this.$refs.addInvoice.invoiceData.basicId = this.basicId;
          this.$refs.addInvoice.settlementNum = this.settlementNum;
          this.$refs.addInvoice.otherNum = this.otherNum;
          this.$refs.addInvoice.addOrEdit = 'add';
          this.$refs.addInvoice.getServiceName();
          this.$refs.addInvoice.getSelection(this.purchaserId);
          // this.$refs.addInvoice.settlementNum = this.settlementQuantityCalculation()
        });
      },
      async editTableClick(id) {
        const {
          data,
          status,
          message,
        } = await infoInvoice(id);
        if (status !== 0) return this.$message.warning(message);
        this.addInvoiceVisible = true;
        this.$nextTick(() => {
          this.$refs.addInvoice.invoiceData = data;
          this.$refs.addInvoice.settlementNum = this.settlementNum + data.settlementNum;
          this.$refs.addInvoice.otherNum = this.otherNum;
          this.$refs.addInvoice.addOrEdit = 'edit';
          this.$refs.addInvoice.getServiceName();
          this.$refs.addInvoice.getSelection(this.purchaserId);
        });
      },
      deleteTableClick(id) {
        this.$confirm('确认删除当前发票吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteInvoice(id);
            if (res.status === 0) {
              this.$message.success(res.message);
              await this.getInvoiceList(this.basicId);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {
          });
        this.invoiceTableData.splice(index, 1);
      },
      auditConfirmClick() {
        this.auditData.isSalesList = this.isSalesList;
        this.$refs.ruleForm2.validate(async (valid) => {
          if (valid) {
            const {
              status,
              message,
            } = await submitAuditInvoice({
              id: this.basicId,
              isDetailedList: this.isSalesList,
              type: this.searchForm.type,
              reconciliator: this.auditData.reconciliator
            });
            if (status === 0) {
              this.$message.success(message);
              this.auditVisible = false;
              this.$refs.ruleForm2.resetFields();
              await this.accountList();
            } else {
              this.$message.warning(message);
            }
          } else {
            return false;
          }
        });
      },
      // 获取发票数据
      async getInvoiceList(id) {
        const {
          data,
          status,
          message,
        } = await getInvoiceList(id);
        if (status === 0) {
          this.invoiceTableData = data;
        } else {
          this.$message.warning(message);
        }
      },
      addInvoiceClose(type) {
        if (type === 'confirm') {
          this.getInvoiceList(this.basicId);
        }
        this.addInvoiceVisible = false;
        // this.$refs.ruleForm.resetFields();
      },
    },
  };
</script>

<style scoped>

</style>
